import { FC } from 'react';
import { cn } from '@/shared/lib';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@/entities';
import { useChangeLanguage } from '@/features/profile/hooks';

export const LanguageToggle: FC = () => {
  const { t } = useTranslation();
  const { changeLanguage, currentLanguage } = useChangeLanguage();

  return (
    <div className='flex items-center py-2'>
      <span className='text-sm leading-5 text-muted-foreground pr-2'>{t('profile.language')}:</span>

      <div className='flex items-center gap-1'>
        {SUPPORTED_LANGUAGES.map((lang) => {
          const active = lang.code === currentLanguage;
          return (
            <button
              key={lang.code}
              type='button'
              onClick={() => changeLanguage(lang.code)}
              className={cn(
                'flex size-9 items-center justify-center border text-base uppercase',
                active ? 'border-primary text-primary' : 'border-border text-foreground cursor-pointer',
              )}
            >
              {lang.code}
            </button>
          );
        })}
      </div>
    </div>
  );
};
